import { render, staticRenderFns } from "./UIInteractions.vue?vue&type=template&id=3d3b2b7a"
import script from "./UIInteractions.vue?vue&type=script&lang=ts"
export * from "./UIInteractions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports